export default [
  {
    Header: 'FC',
    id: 'fulfillmentCenter.name',
    accessor: 'fulfillmentCenter.name',
    width: 300,
  },
  {
    Header: 'Loja (Canal)',
    id: 'salesChannel.name',
    accessor: 'salesChannel.name',
    width: 300,
  },
]
